import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-new-tests",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#creating-new-tests",
        "aria-label": "creating new tests permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Creating new tests`}</h1>
    <p>{`You can create new tests by simply creating a new json file and adding the required keys, but to make the process more easier, you can use the `}<inlineCode parentName="p">{`create`}</inlineCode>{` command in Vibranium.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`❯ vc c -h                                  
Usage: vc create|c [options]

Create a new scenario test file

Options:
  -c --collection <collection>  Collection Name
  -s --scenario <scenario>      Scenario Name
  -t --template [template]      Create scenario with a template. [t1|t2|t3|e1_github] (default: "t1")
  -h, --help                    output usage information
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`While creating tests, you need to specify the collection in which the tests needs to be created using the `}<inlineCode parentName="p">{`-c`}</inlineCode>{` option and the scenario name using the `}<inlineCode parentName="p">{`-s`}</inlineCode>{` option.`}</p>
    </blockquote>
    <h2 {...{
      "id": "templates",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#templates",
        "aria-label": "templates permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Templates`}</h2>
    <p>{`Vibranium provides a set of templates that you can use to create tests. These templates can be used by specifying the template name in the `}<inlineCode parentName="p">{`--template`}</inlineCode>{` option. They are usually named `}<inlineCode parentName="p">{`t1`}</inlineCode>{` to `}<inlineCode parentName="p">{`tn`}</inlineCode>{` where each increment stands for increase in complexity. The templates starting with `}<inlineCode parentName="p">{`e`}</inlineCode>{` are example templates, like `}<inlineCode parentName="p">{`e1_github`}</inlineCode>{` refers to example of github API v3.`}</p>
    <h3 {...{
      "id": "user-provided-templates",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#user-provided-templates",
        "aria-label": "user provided templates permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`User provided Templates`}</h3>
    <p>{`You can have user provided templates also. If you want to have a standard structure for all your tests, you can create a template json and place it in the templates directory inside the tests directory in your workspace. For example, if I have my workspace at `}<inlineCode parentName="p">{`˜/workspace`}</inlineCode>{` and my tests directory is named `}<inlineCode parentName="p">{`Vibranium-Tests`}</inlineCode>{`, then I'll have a directory structure for my templates as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`˜/
  workspace/
    config.json
    jobs/
      latest/
      job_n/
    logs/
    Vibranium-Tests/
      scenarios/
      payloads/
      schemas/
      templates/
        template_myCustomTemplate.json
        template_myComplexTemplate.json
`}</code></pre>
    <p>{`To use the templates, I can use either `}<inlineCode parentName="p">{`vc c --template myCustomTemplate`}</inlineCode>{` or `}<inlineCode parentName="p">{`vc c --template myComplexTemplate`}</inlineCode></p>
    <blockquote>
      <p parentName="blockquote">{`Make sure the directory structure is correct and that you prefix the templates with `}<inlineCode parentName="p">{`template_`}</inlineCode>{`for user provided templates to work.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      